module.exports = __webpack_public_path__ + "img/20191122163956360截图20191122163055782.dd17f19c.jpg";